<template>
 <!-- List of played tickets -->
  <div class="a-vs-aside--played-tickets">
    <h3>{{ $t('active_bets') }}</h3>
    <!-- Single upcoming match card -->
    <div class="a-vs-aside--ticket-wrap" >
      <active-ticket
        class="a-vs-c--single-ticket single-ticket__success"
        v-for="(ticket, index) in tickets" :key="index"
        :ticket="ticket"
        :showPossibleWin="true"/>
    </div>
    <button class="a-vs-c--button  betting-history" @click="showBettingHistory()">{{$t('betting_history')}}</button>
</div>
</template>

<script>
import Vue from 'vue'
import TimeFormatter from '@/mixins/TimeFormatter'
import ActiveTicket from '@/components/soccer/ticket/ActiveTicket'
import api from '@/services/soccer/api.service.network.js'
import EventConstants from '@/constants/Events'
import { eventBus } from '@/main.js'

import vuexStore from '../../../store/vuexStore'

import generalMenuSound from '../../../assets/audio/general_menu.mp3'

export default {
  components: {
    'active-ticket': ActiveTicket
  },
  mixins: [TimeFormatter],
  data () {
    return {
      tickets: [],
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    processOpenTickets (data) {
      if (data.Tickets) {
        var openTicketes = {}
        this.tickets.forEach((element, index) => {
          openTicketes[index] = element.isOpen
        })
        data.Tickets.forEach((element, index) => {
          Vue.set(element, 'isOpen', openTicketes[index] || false)
        })
        this.tickets = data.Tickets.filter(ticket => ticket.Status === 2)
        this.tickets.sort((t1, t2) => t2.DateTime.localeCompare(t1.DateTime))
        eventBus.onChangeNumberOfActiveTickets(this.tickets.length)
      }
    },
    getGetOpenTickets () {
      setTimeout(() => {
        api.getGetOpenTickets().subscribe(this.processOpenTickets, eventBus.onApiError)
        api.getBalance()
      }, 700)
    },
    showBettingHistory: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      eventBus.showBettingHistory(true)
    }
  },
  created: function () {
    this.getGetOpenTickets()
    eventBus.$on(EventConstants.VSOCCER_TICKET_INSERTED, this.getGetOpenTickets)
    eventBus.$on(EventConstants.VSOCCER_REFRESH_ACTIVE_BETS, this.getGetOpenTickets)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_TICKET_INSERTED, this.getGetOpenTickets)
    eventBus.$off(EventConstants.VSOCCER_REFRESH_ACTIVE_BETS, this.getGetOpenTickets)
  }
}
</script>
